export const isMixpanelReady = () => {
  const mp = window?.mixpanel;
  if (!mp) return false;
  if (typeof mp.get_distinct_id !== "function" || typeof mp.get_property !== "function") {
    return false;
  }

  return Boolean(mp.get_distinct_id() && mp.get_property("session ID"));
};

export const waitForMixpanelReady = (onReady, { intervalMs = 150, timeoutMs = 10000 } = {}) => {
  const start = Date.now();
  const tick = () => {
    if (isMixpanelReady()) {
      onReady();
      return;
    }
    if (timeoutMs > 0 && Date.now() - start >= timeoutMs) {
      onReady();
      return;
    }
    setTimeout(tick, intervalMs);
  };
  tick();
};
